module.exports = __webpack_public_path__ + "assets/img/d908500182129be6882dc9869c7ef67e.svg";